module.exports = __webpack_public_path__ + "media/images/menu/saturn-1d1d57f331a4dcbe713891de6a7546d9.jpg";